import 'sweetalert2/dist/sweetalert2.css';
import showSwalMixin from '@/mixins/showSwal';
import showToast from '@/util/toast';
import { scrollToRight } from '@/util/scrollToBorder';
import { showConfirmSwal } from '@/util/swal';
import { createNamespacedHelpers } from 'vuex';

import ImagesListModal from '@/components/shared/ImagesListModal/ImagesListModal.vue';
import LoadingSpinner from '@/components/shared/SkeletonSpinner/SkeletonSpinner.vue';

const globalMapper = createNamespacedHelpers('global');
const authMapper = createNamespacedHelpers('global/auth');

const trainerMapper = createNamespacedHelpers('trainer');
const imageMapper = createNamespacedHelpers('trainer/image');
const modelMapper = createNamespacedHelpers('trainer/model');

const INIT_SKIP = 0;
// Limit the number of images geted one time
const LIMIT = 10;
// Minimum number of image requirements to train
const MIN_COUNT = 20;
const SUFFIX = 'trainer';

export default {
	name: 'ImagePreview',

	mixins: [showSwalMixin],

	components: {
		ImagesListModal,
		LoadingSpinner,
	},

	data() {
		return {
			slide: 0,
			threshold: 0.5,
			createdModelInformation: {},
			imagesModalId: 'trainerImagesMmodal',
			hasBorder: false,
			hasTag: false,
			onChooseDeleteModel: '',
			localSavedModel: '',
			trainerLocalModel: '',
			suffix: SUFFIX,
			minImageCount: MIN_COUNT,
		};
	},

	props: {
		retrainModalId: {
			type: String,
		},
	},

	computed: {
		...authMapper.mapState(['username']),
		...imageMapper.mapState(['images', 'allImagesCount']),
		...imageMapper.mapGetters(['reversedImages']),
		...modelMapper.mapState(['models', 'model']),

		confirmContent() {
			return {
				title: this.$t('Warning'),
				text: this.$t('confirmDeleteAllImages'),
				yesButton: this.$t('confirmYes'),
				noButton: this.$t('confirmNo'),
			};
		},

		passedImages() {
			return {
				imagesList: this.reversedImages,
				from: 'trainer',
			};
		},

		isModalVisible: {
			get() {
				return this.$store.state.trainer.isModalVisible;
			},
			set(value) {
				this.$store.dispatch('trainer/showFormModal', value);
			},
		},

		imagesNumber() {
			return this.images.length;
		},

		isStopRetrieImageByScroll() {
			return this.images.length >= this.allImagesCount;
		},

		numberOfPhotosNeeded() {
			if (this.allImagesCount >= MIN_COUNT) {
				return 0;
			}
			return MIN_COUNT - this.allImagesCount;
		},
	},

	methods: {
		...globalMapper.mapActions(['setSpinner']),
		...trainerMapper.mapActions(['loadModel', 'hideFormModal']),
		...imageMapper.mapActions([
			'retrieveUploadedImagesInit',
			'deleteImage',
			'startLearn',
			'retrieveUploadedImagesPaginated',
			'deleteLocalImages',
			'resetTrainerImages',
			'deleteOneImage',
		]),
		...imageMapper.mapMutations(['SET_STEP2']),
		...modelMapper.mapActions(['retrieveModels', 'setModel', 'deleteModel']),

		deleteItemModal(image, idx, event) {
			event.stopPropagation();

			const deleteItem = async () => {
				this.setSpinner(true);
				try {
					await this.deleteImage({
						username: this.username,
						file_name: image.imageName,
						s3_key: image.imageKey,
						image_type: image.imageType,
						id: image.imageId,
						index: idx,
					});
					this.setSpinner(false);

					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('successDeleteImage'),
					});
					this.SET_STEP2();

					//  *** tạm cmt out sẽ revert lại ***
					// await this.retrieveUploadedImagesInit({
					// 	username: this.username,
					// 	skip: INIT_SKIP,
					// 	limit: LIMIT,
					// });
				} catch (error) {
					this.setSpinner(false);
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('failDeleteImage'),
					});
				}
			};

			showConfirmSwal(
				{
					title: this.$t('confirnDelete'),
					text: this.$t('confirmDeleteImage'),
					yesButton: this.$t('confirmYes'),
					noButton: this.$t('confirmNo'),
				},
				deleteItem,
				() => {}
			);
		},

		/**
		 * Handle when imagelist scroll to right
		 */
		handleScroll() {
			const imageList = document.getElementById('images-list');

			const callback = async () => {
				if (this.isStopRetrieImageByScroll) return;
				this.setSpinner(true);
				try {
					await this.retrieveUploadedImagesPaginated({
						username: this.username,
						skip: this.images.length,
						limit: LIMIT,
					});
				} catch (error) {
					console.log(error);
				}
				this.setSpinner(false);
			};

			scrollToRight(imageList, callback);
		},

		onImageListClick() {
			if (!this.images.length) return;
			this.$bvModal.show(this.imagesModalId);
		},
		/**
		 * Each image click handleder
		 * @param {Number} idx
		 */
		onImageClick(idx) {
			this.$bvModal.show(this.imagesModalId);
			this.slide = idx;
		},

		openRetrainModal() {
			this.$store.commit('history/UPDATE_NO_CHECKBOX', true);
			this.$bvModal.show(this.retrainModalId);
		},

		onDeleteAllImage() {
			const confirm = async () => {
				await this.deleteLocalImages({ username: this.username });
				this.resetTrainerImages();
				this.SET_STEP2();
			};
			const dismiss = () => {
				this.SET_STEP2();
			};

			showConfirmSwal(this.confirmContent, confirm, dismiss);
		},
	},

	async mounted() {
		await this.retrieveModels({ username: this.username });

		// when there is not model, delete model saved in localstorage
		if (!this.model) {
			this.trainerLocalModel = localStorage.removeItem(
				`${this.username}-${this.suffix}`
			);
		}
		// when there is model, load model saved in localstorage
		else {
			let savedModel = localStorage.getItem(`${this.username}-${this.suffix}`);
			this.setModel({ model: savedModel ? savedModel : this.model });
			this.trainerLocalModel = savedModel;
		}

		/**
		 * will revert soon
		 */
		// await this.retrieveUploadedImagesInit({
		// 	username: this.username,
		// 	skip: INIT_SKIP,
		// 	limit: LIMIT,
		// });
		// this.handleScroll();
	},
};
